import { render, staticRenderFns } from "./WfConsumerCorpForm.vue?vue&type=template&id=76a2eb44&"
import script from "./WfConsumerCorpForm.vue?vue&type=script&lang=js&"
export * from "./WfConsumerCorpForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports